import ri from "./trigger-condition.js";
export default class lr {
  constructor(t) {
    (this.xu = t), (this.xu = t);
  }
  Bl(t) {
    return null == this.xu || ri.Bu(t[0], this.xu);
  }
  static fromJson(t) {
    return new lr(t ? t.campaign_id : null);
  }
  ss() {
    return this.xu;
  }
}
